import _ from 'lodash'
import store from '../store'
import * as types from '../store/types'

if (_.preload('user.data')) {
    store.commit(types.users.modules.current.mutations.found, {
        item: _.preload('user')
    })
}

if (_.preload('landlord.data')) {
    store.commit(types.landlords.modules.current.mutations.found, {
        item: _.preload('landlord')
    })
}

if (_.preload('tenant.data')) {
    store.commit(types.tenants.modules.current.mutations.found, {
        item: _.preload('tenant')
    })
}

if (_.preload('residency.data')) {
    store.commit(types.residencies.modules.current.mutations.found, {
        item: _.preload('residency')
    })
}

if (_.preload('invitation.data')) {
    store.commit(types.invitations.modules.current.mutations.found, {
        item: _.preload('invitation')
    })
}
